import * as Sentry from '@sentry/nextjs';

const UUID_TEMPLATE = /[xy]/g;

// ponytail: non-HTTPS fallback — crypto.randomUUID() throws outside secure contexts
const fallbackUUID = (): string =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(UUID_TEMPLATE, (char) => {
    const random = Math.floor(Math.random() * 16);
    // y must be one of 8, 9, a, b per the UUID v4 spec
    const value = char === 'x' ? random : (random % 4) + 8;
    return value.toString(16);
  });

/**
 * Generate a UUID, falling back to a non-crypto implementation in insecure
 * (non-HTTPS) contexts where crypto.randomUUID() throws.
 */
export const generateUUID = (): string => {
  try {
    return crypto.randomUUID();
  } catch (error) {
    Sentry.captureException(error, { tags: { function: 'generateUUID' } });

    return fallbackUUID();
  }
};
